import React from "react";
import { BsTrash } from "react-icons/bs";
import { mediaUrl as imgUrl } from "../../../functions/mediaUrl";

const Field = ({ label, value }) => {
  return (
    <div className="flex text-sm">
      <span className="text-gray-500 w-40">{label}</span>
      <span className="text-[#060a24]">{value || "-"}</span>
    </div>
  );
};

const ObjectCard = ({ object, onClick, onDelete }) => {
  const { naam, nummer, telefoonnummer, bouwjaar, locatie, contactpersoon, media } = object;

  const adres = [
    [locatie?.adres, locatie?.huisnummer].filter(Boolean).join(" "),
    [locatie?.postcode, locatie?.plaats].filter(Boolean).join(" "),
  ]
    .filter(Boolean)
    .join(", ");

  const hasContact =
    contactpersoon?.naam || contactpersoon?.telefoon || contactpersoon?.email;

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onClick()}
      className="flex gap-4 p-3 bg-white border border-gray-200 rounded-md hover:shadow-md hover:bg-gray-50 cursor-pointer transition"
    >
      {/* Foto */}
      <div className="w-[200px] h-[200px] shrink-0 rounded bg-gray-100 overflow-hidden flex items-center justify-center">
        {media?.url ? (
          <img
            src={imgUrl(media.url)}
            alt={naam || "Object"}
            className="w-full h-full object-cover"
          />
        ) : (
          <span className="text-gray-400 text-xs">geen foto</span>
        )}
      </div>

      {/* Info */}
      <div className="flex-1 min-w-0">
        {/* Naam + verwijder */}
        <div className="flex items-center justify-between mb-2">
          <span className="font-semibold text-[#060a24]">
            {naam || "(geen naam)"}
            {nummer ? (
              <span className="font-normal text-gray-500 ml-2">#{nummer}</span>
            ) : null}
          </span>
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
            className="p-1.5 text-gray-400 hover:text-[#d63230] hover:bg-red-50 rounded shrink-0"
            aria-label="Verwijder object"
          >
            <BsTrash size={15} />
          </button>
        </div>

        {/* Object gegevens */}
        <div className="space-y-0.5">
          <Field label="Adres" value={adres} />
          <Field label="Bouwjaar" value={bouwjaar} />
          <Field label="Telefoon" value={telefoonnummer} />
        </div>

        {/* Contactpersoon */}
        <div className="mt-2 pt-2 border-t border-gray-100 space-y-0.5">
          <Field label="Contactpersoon" value={contactpersoon?.naam} />
          <Field label="Telefoon" value={contactpersoon?.telefoon} />
          <Field label="E-mail" value={contactpersoon?.email} />
        </div>
      </div>
    </div>
  );
};

export default ObjectCard;
